import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,           // 30s
      gcTime: 5 * 60 * 1000,          // 5 min
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
